<template>
  <div>
    <v-col cols="12" class="text-center">
      <h3 class="mb-4">¿Está seguro de que desea eliminar esta referencia?</h3>
      <v-row justify="center">
        <v-col cols="auto">
          <v-btn text @click="$emit('close')">Cancelar</v-btn>
        </v-col>
        <v-col cols="auto">
          <TextButton color="error" @click="confirmEliminacion">Confirmar</TextButton>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import TextButton from '@src/components/base/TextButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  name: 'ConfirmacionEliminarReferenciaDialogComponent',
  components: {
    TextButton,
  },
  data() {
    return {
      DIALOG_TYPES,
    }
  },
  props: {
    dialog: { type: Boolean, default: false },
    onConfirm: { type: Function, required: true },
  },
  methods: {
    confirmEliminacion() {
      this.onConfirm()
    },
  },
}
</script>
